import React from "react";
import styled from "styled-components";
import { isMobile } from "react-device-detect";

const OsCounter = styled.span.attrs({
  className: "heading-spacing-2140",
})`
  line-height: 100%;
  letter-spacing: 0;
  user-select: none;

  position: absolute;
  top: ${isMobile ? "-12px" : "-12px"};
  left: 0px;

  width: clamp(3rem, 2.61rem + 1.95vw, 4rem);
  height: clamp(3rem, 2.61rem + 1.95vw, 4rem);

  border-radius: 50%;
  border: 1px solid var(--soremo-border);

  display: flex;
  align-items: center;
  justify-content: center;

  background: var(--soremo-gray);
  color: #fff;

`;

// やることカードの連番。円で囲わず、オファー作成のロール選択カード
// （RolePicker の RotatedCreditTitle）と同じ DIN 2014 の文字表現で直接置く。
const TodoCounter = styled.span`
  font-family: "din-2014", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 64px;
  line-height: 100%;
  letter-spacing: 0.08em;
  user-select: none;
  pointer-events: none;

  position: absolute;
  top: 12px;
  left: 12px;

  color: #ffffff;
  mix-blend-mode: difference;
  opacity: 0.7;
`;
const Counter = ({ number, type }) => {
  return <>
  {type === "os" && <OsCounter>{number}</OsCounter>}
  {type === "todo" && <TodoCounter>{number}</TodoCounter>}
  </>;
};

export default Counter;
